import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import LandingPage from './pages/LandingPage';
import CustomerDashboard from './pages/customer/Dashboard';
import CustomerCredits from './pages/customer/Credits';
import WarrantyActivation from './pages/customer/WarrantyActivation';
import PaymentVerification from './pages/customer/PaymentVerification';
import ClaimSubmission from './pages/customer/ClaimSubmission';
import ClaimStatus from './pages/customer/ClaimStatus';
import AdminDashboard from './pages/admin/Dashboard';
import AdminWarranties from './pages/admin/Warranties';
import AdminClaims from './pages/admin/Claims';
import AdminCredits from './pages/admin/Credits';
import AdminUsers from './pages/admin/Users';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route
            path="/customer/*"
            element={
              <PrivateRoute requiredRole="customer">
                <Routes>
                  <Route path="dashboard" element={<CustomerDashboard />} />
                  <Route path="credits" element={<CustomerCredits />} />
                  <Route path="activate-warranty" element={<WarrantyActivation />} />
                  <Route path="payment-verification" element={<PaymentVerification />} />
                  <Route path="submit-claim/:warrantyId" element={<ClaimSubmission />} />
                  <Route path="claim-status/:id" element={<ClaimStatus />} />
                  <Route path="*" element={<Navigate to="/customer/dashboard" replace />} />
                </Routes>
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/*"
            element={
              <PrivateRoute requiredRole="admin">
                <Routes>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="warranties" element={<AdminWarranties />} />
                  <Route path="claims" element={<AdminClaims />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="credits" element={<AdminCredits />} />
                  <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                </Routes>
              </PrivateRoute>
            }
          />

          <Route path="/" element={<LandingPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

